<template>
  <!-- Built on the codebase's canonical summary-tile idiom (cf. AgentSummaryCard / FactoryScheduleCard):
       v-card[background, elevated, elevation 4] + v-card-item slots + v-card-text chip row. -->
  <v-card
    color="background"
    variant="elevated"
    elevation="4"
    class="automation-card fill-height d-flex flex-column"
    @click="$emit('open', automation.id)"
  >
    <v-card-item class="pb-2">
      <template #prepend>
        <v-avatar color="primary" variant="tonal" rounded="lg" size="44">
          <v-icon :icon="meta.icon" />
        </v-avatar>
      </template>
      <v-card-title class="text-truncate">{{ automation.name }}</v-card-title>
      <template #append>
        <v-chip
          size="x-small"
          variant="tonal"
          :color="automation.status === 'active' ? 'success' : 'grey'"
        >
          {{ automation.status === 'active' ? 'Active' : 'Paused' }}
        </v-chip>
      </template>
    </v-card-item>

    <v-card-text class="pt-0 flex-grow-1">
      <p class="text-body-2 text-medium-emphasis mb-0 automation-card__job">{{ automation.job }}</p>
    </v-card-text>

    <v-divider />
    <v-card-text class="py-3">
      <div class="d-flex align-center ga-2 text-caption text-medium-emphasis">
        <v-icon icon="mdi-clock-outline" size="small" color="primary" />
        <span class="text-primary">{{ whenLabel }}</span>
        <v-spacer />
        <span class="text-disabled text-uppercase">{{ meta.label }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { TYPE_META, whenLine } from '@/data/automations'
import type { Automation } from '@/types/automations'

@Options({
  props: {
    automation: { type: Object, required: true }
  },
  emits: ['open']
})
export default class AutomationCard extends Vue {
  automation!: Automation

  get meta() {
    return TYPE_META[this.automation.type]
  }

  get whenLabel(): string {
    return whenLine(this.automation.when)
  }
}
</script>

<style scoped lang="scss">
.automation-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.08);
  cursor: pointer;
  transition: border-color 0.16s, transform 0.16s;

  &:hover {
    border-color: rgb(var(--v-theme-primary));
    transform: translateY(-2px);
  }

  &__job {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
